import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Typography, Card, DatePicker, message } from 'antd';
import dayjs from 'dayjs';
import apiService from '../../services/api';

const { Title, Text } = Typography;

const fmtMoney = (v) => `£${Number(v || 0).toFixed(2)}`;

const ExternalDrivers = () => {
  const navigate = useNavigate();
  const [selectedMonth, setSelectedMonth] = useState(dayjs());
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);

  const monthStr = selectedMonth.format('YYYY-MM');

  useEffect(() => {
    let stale = false;
    setLoading(true);
    apiService.driverWages.getExternal(monthStr)
      .then(res => { if (!stale) setDrivers(res.data || []); })
      .catch(() => { if (!stale) message.error('Failed to load external drivers'); })
      .finally(() => { if (!stale) setLoading(false); });
    return () => { stale = true; };
  }, [monthStr]);

  const sum = (field) => drivers.reduce((s, d) => s + (d[field] || 0), 0);

  const columns = [
    { title: 'Driver', dataIndex: 'name', key: 'name', render: (name) => <Text strong>{name}</Text> },
    { title: 'Days Worked', dataIndex: 'daysWorked', key: 'daysWorked', align: 'center', width: 110 },
    { title: 'Jobs', dataIndex: 'jobs', key: 'jobs', align: 'center', width: 80 },
    { title: 'Charged', dataIndex: 'charged', key: 'charged', align: 'right', width: 120, render: fmtMoney },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 8 }}>
        <Title level={4} style={{ margin: 0 }}>External Drivers</Title>
        <DatePicker
          picker="month"
          value={selectedMonth}
          onChange={(d) => d && setSelectedMonth(d)}
          allowClear={false}
          format="MMMM YYYY"
          style={{ width: 160 }}
        />
      </div>

      <Card size="small">
        <Table
          dataSource={drivers}
          columns={columns}
          rowKey="_id"
          loading={loading}
          pagination={false}
          size="small"
          scroll={{ x: 'max-content' }}
          locale={{ emptyText: 'No external drivers worked this month' }}
          onRow={(record) => ({
            onClick: () => navigate(`/daily-runs/external-drivers/${record._id}?name=${encodeURIComponent(record.name)}&month=${monthStr}`),
            style: { cursor: 'pointer' },
          })}
          summary={() =>
            drivers.length > 0 ? (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}><Text strong>Total</Text></Table.Summary.Cell>
                <Table.Summary.Cell index={1} />
                <Table.Summary.Cell index={2} align="center"><Text strong>{sum('jobs')}</Text></Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="right"><Text strong>{fmtMoney(sum('charged'))}</Text></Table.Summary.Cell>
              </Table.Summary.Row>
            ) : null
          }
        />
      </Card>
    </div>
  );
};

export default ExternalDrivers;
